import React from 'react';

import { Tag } from 'antd';

import styled from 'styled-components';

export const Wrapper = styled.div`
    max-width: 27rem;

    .legal-card-title-wrapper {
        position: relative;
        display: flex;

        .legal-card-title {
            padding-left: 1rem;
            line-height: 0.5;
            &.invalid {
                padding-left: 4rem;
            }
        }

        /* Su mobile non c'e' il ribbon sovrapposto: il titolo non deve lasciargli spazio
           e va allineato al tag di stato che lo precede */
        @media (max-width: 720px) {
            align-items: center;

            .legal-card-title,
            .legal-card-title.invalid {
                padding-left: 0;
            }
        }
    }

    .legal-years-selector {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 0.5rem;
        align-items: center;
        padding-bottom: 1rem;

        .legal-year-selector-item {
            padding: 0.15rem 0.75rem;
            border-radius: 4px;
            color: #fff;
            font-size: ${(props) => props.theme.FontSizeSm};
            background-color: ${(props) => props.theme.BackgroundColor};
            cursor: pointer;
            opacity: 0.25;

            &:hover,
            &.selected {
                opacity: 1;
            }
            &.valid {
                background-color: ${(props) => props.theme.PrimaryColor};
            }
            &.invalid {
                background-color: ${(props) => props.theme.DangerColor};
            }
        }
    }

    .legal-details-instance {
        margin: 1rem 0 2rem 0;

        /* .legal-details-instance-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        } */
    }

    .legal-details-content {
        .legal-details-content-add-button-wrapper {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            min-height: 8rem;
        }

        .legal-details {
            margin-bottom: 0.5rem;
            display: flex;
            flex-direction: row;
            gap: 0.25rem;
            align-items: flex-start;
            justify-content: flex-start;
            .legal-details-label {
                min-width: 8rem;
                text-transform: uppercase;
                font-size: ${(props) => props.theme.FontSizeSm};
                color: ${(props) => props.theme.TextColorMuted};
                padding-top: 0.15rem;
            }
            .legal-details-value {
                font-weight: 600;
            }
            .legal-details-button {
                margin-left: auto;
            }
        }
    }
`;

export const StyledTag = styled(Tag)`
    margin-right: 8px;
`;

export const LegalDetails = ({ label, value, button }) => {
    return (
        <div className="legal-details">
            <div className="legal-details-label">{label}</div>
            <div className="legal-details-value">{value}</div>
            {button && <div className="legal-details-button">{button}</div>}
        </div>
    );
};
